module.exports = __webpack_public_path__ + "media/Video 48.ea0cf599.mp4";